
/** 
 

 
 
 * */
import React from 'react';
export default function MainHeader(props: any) {
    return (
        <div className="css_class_0" role={`navigation`} style-extractor={`0`}  >
            {props.children}
        </div>
    )
}